

export const removeFooter = (): void => {
    const footer = document.getElementsByTagName('footer')[0]
    if (footer) {
        footer.style.display = 'none'
    }
}

export const removeNavigation = (): void => {
    const navigation = document.getElementById(
        'top-navigation'
    ) || { style: { display: 'none' } }
    navigation.style.display = 'none'
    }

export const simpleFooter = (): void => {
    const footer = document.getElementsByTagName('footer')[0]
    if (footer) {
        footer
            .querySelectorAll(
                '[data-simpleFooter="remove"]'
            )
            .forEach((element: HTMLElement) => {
                element.style.display = 'none'
            })
    }
}